import React from "react";
import ProductBankImageFrame from "./ProductBankImageFrame";
import {
  ProductImageSource,
  shouldUseProductImageFrame,
} from "../../Utils/productImage/productImageDisplay";

export type ProductAwareStillImageProps = {
  src: string;
  alt?: string;
  /** Post/row data used for `type === "PRODUCT"` detection. */
  post?: ProductImageSource;
  /** Optional carousel/component type (e.g. product-bank). */
  type?: string | null;
  /** Media shape from carousel settings: "sq" → 143×143. */
  shape?: string | boolean | null;
  /** Alias when caller already knows square. */
  square?: boolean;
  /** Legacy classNames for non-PRODUCT still images (UI unchanged). */
  className?: string;
  style?: React.CSSProperties;
  loading?: "eager" | "lazy";
  /** Hint for LCP / above-the-fold thumbs (maps to img fetchpriority). */
  fetchPriority?: "high" | "low" | "auto";
  onError?: React.ReactEventHandler<HTMLImageElement>;
};

/**
 * Renders ProductBankImageFrame for PRODUCT posts; otherwise a normal <img>
 * so shoppable/content carousel UI stays unchanged for non-product media.
 */
const ProductAwareStillImage = ({
  src,
  alt = "post",
  post,
  type,
  shape,
  square,
  className,
  style,
  loading,
  fetchPriority,
  onError,
}: ProductAwareStillImageProps) => {
  if (!src) return null;

  if (shouldUseProductImageFrame(type, post)) {
    return (
      <ProductBankImageFrame
        src={src}
        alt={alt}
        fill
        shape={shape}
        square={square}
        loading={loading}
        onError={onError}
      />
    );
  }

  return (
    <img
      className={className}
      src={src}
      alt={alt}
      style={style}
      loading={loading}
      onError={onError}
      // React DOM wants lowercase; camelCase warns in dev.
      fetchpriority={fetchPriority}
    />
  );
};

export default ProductAwareStillImage;
